import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M12.929 4.65H1.147c-.355 0-.609.279-.609.609V7.29c0 .356.254.61.61.61h11.78c.33 0 .61-.254.61-.61V5.259c0-.33-.28-.61-.61-.61Zm-9.14 2.437H1.35V5.462h2.437v1.625Zm8.937 0H4.6V5.462h8.125v1.625Zm.203-6.5H1.147c-.355 0-.609.28-.609.61v2.03c0 .356.254.61.61.61h11.78c.33 0 .61-.254.61-.61v-2.03c0-.33-.28-.61-.61-.61ZM8.663 3.024H1.351V1.4h7.312v1.625Zm4.063 0h-3.25V1.4h3.25v1.625Zm.203 5.688H1.147c-.355 0-.609.28-.609.61v2.03c0 .356.254.61.61.61h11.78c.33 0 .61-.254.61-.61v-2.03c0-.33-.28-.61-.61-.61Zm-5.89 2.437H1.35V9.524h5.687v1.625Zm5.687 0H7.85V9.524h4.875v1.625Z",
      fill: "currentColor"
    })
  }));
};
export default SvgComponent;